/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Placeholder_Master_ResumeInputs */

const en_keyword_optimizer_placeholder_master_resume = /** @type {(inputs: Keyword_Optimizer_Placeholder_Master_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master resume`)
};

const de_keyword_optimizer_placeholder_master_resume = /** @type {(inputs: Keyword_Optimizer_Placeholder_Master_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master resume`)
};

const fr_keyword_optimizer_placeholder_master_resume = /** @type {(inputs: Keyword_Optimizer_Placeholder_Master_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master resume`)
};

const es_keyword_optimizer_placeholder_master_resume = /** @type {(inputs: Keyword_Optimizer_Placeholder_Master_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master resume`)
};

const it_keyword_optimizer_placeholder_master_resume = /** @type {(inputs: Keyword_Optimizer_Placeholder_Master_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master resume`)
};

const nl_keyword_optimizer_placeholder_master_resume = /** @type {(inputs: Keyword_Optimizer_Placeholder_Master_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master resume`)
};

const pl_keyword_optimizer_placeholder_master_resume = /** @type {(inputs: Keyword_Optimizer_Placeholder_Master_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master resume`)
};

const fi_keyword_optimizer_placeholder_master_resume = /** @type {(inputs: Keyword_Optimizer_Placeholder_Master_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master resume`)
};

const da_keyword_optimizer_placeholder_master_resume = /** @type {(inputs: Keyword_Optimizer_Placeholder_Master_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master resume`)
};

const sv_keyword_optimizer_placeholder_master_resume = /** @type {(inputs: Keyword_Optimizer_Placeholder_Master_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master resume`)
};

/**
* | output |
* | --- |
* | "Master resume" |
*
* @param {Keyword_Optimizer_Placeholder_Master_ResumeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_placeholder_master_resume = /** @type {((inputs?: Keyword_Optimizer_Placeholder_Master_ResumeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Placeholder_Master_ResumeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_placeholder_master_resume(inputs)
	if (locale === "fr") return fr_keyword_optimizer_placeholder_master_resume(inputs)
	if (locale === "es") return es_keyword_optimizer_placeholder_master_resume(inputs)
	if (locale === "it") return it_keyword_optimizer_placeholder_master_resume(inputs)
	if (locale === "nl") return nl_keyword_optimizer_placeholder_master_resume(inputs)
	if (locale === "pl") return pl_keyword_optimizer_placeholder_master_resume(inputs)
	if (locale === "fi") return fi_keyword_optimizer_placeholder_master_resume(inputs)
	if (locale === "da") return da_keyword_optimizer_placeholder_master_resume(inputs)
	if (locale === "sv") return sv_keyword_optimizer_placeholder_master_resume(inputs)
	return en_keyword_optimizer_placeholder_master_resume(inputs)
});